<template>
<div id="app">
  <div id="title">
    <div id="logo">
      <el-image
      style="width: 112px; height: 50px; margin-top:5px; margin-left:30px"
      :src="logoUrl"
      fit="contain"></el-image>
    </div>
    <div id="menus">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
    style="float: right; margin-right: 100px;"
    active-text-color="#409EFF">
      <el-menu-item index="/index" style="font-size: 16px">首页</el-menu-item>
      <el-menu-item index="/introduction" style="font-size: 16px">公司简介</el-menu-item>
      <el-menu-item index="/products" style="font-size: 16px">产品中心</el-menu-item>
      <el-menu-item index="/news" style="font-size: 16px">新闻资讯</el-menu-item>
      <el-menu-item index="/about" style="font-size: 16px">联系我们</el-menu-item>
    </el-menu>
    </div>
  </div>
  <div class="content">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
  <el-backtop class="el-backtop" :bottom="60" style="right:0px;" :visibility-height="100"></el-backtop>
  <div class="bottom">
    <div class="bt-info">
      <div class="bt-comp">
        <el-image
        style="width: 300px; height: auto; margin-top:10px; margin-left:60px;"
        :src="logoWitheUrl"
        fit="contain"></el-image>
        <br><br>
        <span class="bt-comp-li"><i class="el-icon-location-outline"></i>&nbsp;&nbsp;河南省郑州市中牟新区官渡生物医药产业园区碣石路3号</span>
        <br><br>
        <span class="bt-comp-li"><i class="el-icon-phone-outline"></i>&nbsp;&nbsp;0371-5652 8599</span>
        <br><br>
        <span class="bt-comp-li"><i class="el-icon-message"></i>&nbsp;&nbsp;shanjieyl@163.com</span>
      </div>
      <div class="bt-menu">
        <span style="font-size: 21px; color:rgb(230, 227, 227)">山杰医疗科技（郑州）有限公司</span>
        <br><br><br>
        <a href="/index"><span class="bt-menu-li"><i class="el-icon-view"></i>&nbsp;&nbsp;首页</span></a>
        <a href="/introduction"><span class="bt-menu-li-right"><i class="el-icon-view"></i>&nbsp;&nbsp;公司简介</span></a>
        <a href="/products"><span class="bt-menu-li-right"><i class="el-icon-view"></i>&nbsp;&nbsp;产品中心</span></a>
        <br><br>
        <a href="/news"><span class="bt-menu-li"><i class="el-icon-view"></i>&nbsp;&nbsp;新闻资讯</span></a>
        <a href="/about"><span class="bt-menu-li-end"><i class="el-icon-view"></i>&nbsp;&nbsp;联系我们</span></a>
      </div>
    </div>
    <div class="bt-copyright">
      Copyright&nbsp;©&nbsp;山杰医疗科技（郑州）有限公司&nbsp;&nbsp;
      <a class="copyA" href="https://beian.miit.gov.cn/" target="_blank">豫ICP备2025109527号</a>&nbsp;&nbsp;
      <a class="copyA" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41012202000403" target="_blank">豫公网安备41012202000403号</a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      activeIndex: '/index',
      logoUrl: require('./assets/logo.png'),
      logoWitheUrl: require('./assets/logo-wx.png')
    }
  },
  mounted () {
    this.activeIndex = this.$route.path
    this.$axios.get('/medical/visit')
  },
  watch: {
    $route: { // 监听路由变化
      handler () {
        this.activeIndex = this.$route.path
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    handleSelect (key) {
      this.$router.push({ path: key })
    }
  }
}
</script>

<style>
body {
  display: block;
  margin: 0px;
  width: 100%;
  min-width: 1820px;
  height: 100%;
  font-size: 16px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #353535;
}
#title{
  width: 100%;
  min-width: 1820px;
  height: 60px;
  line-height: 60px;
  z-index: 999;
  top: 0px;
  background-color: #ffffff;
  box-shadow:0px 2px 2px #e9e7e9;
  position: fixed;
}
.el-backtop {
  width: 40px;
  height: 40px;
  border-radius: 10px 0px 0px 10px;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
#logo{
  width: 350px;
  height: 60px;
  float: left;
  margin-left: 20px;
}
#menus{
  width: 600px;
  height: 60px;
  float: right;
}
.el-backtop {
  background-color: rgba(255, 255, 255, 0.747);
}
.content {
  width: 100%;
  height: auto;
  margin-top: 60px;
}
::-webkit-scrollbar {
    display: none;
}
.bottom {
  width: 100%;
  min-width: 1820px;
  height: 280px;
  background-color: rgba(104, 109, 119, 0.781);
  margin-top: 10px;
}
.bt-info {
  width: 100%;
  height: 230px;
}
.bt-copyright {
  width: 100%;
  height: 40px;
  background-color: rgba(26, 25, 25, 0.836);
  line-height: 40px;
  text-align: center;
  color: rgb(119, 114, 114);
  float: left;
}
.bt-comp {
  width: 50%;
  height: 200px;
  float: left;
  padding-left: 80px;
}
.bt-menu {
  width: 40%;
  height: 210px;
  float: left;
  padding-left: 60px;
  padding-top: 30px;
}
.bt-menu-li {
  font-size: 16px;
  color: rgb(209, 204, 204);
}
.bt-menu-li-right {
  font-size: 16px;
  color: rgb(209, 204, 204);
  margin-left: 70px;
}
.bt-menu-li-end {
  font-size: 16px;
  color: rgb(209, 204, 204);
  margin-left: 38px;
}
a {
  text-decoration: none;
  color: rgb(209, 204, 204);
}
a :hover {
  color: #409EFF;
  cursor: pointer;
}
.bt-comp-li {
  font-size: 16px;
  color: rgb(209, 204, 204);
  margin-left: 60px;
}
.copyA {
  text-decoration: none;
  color: rgb(119, 114, 114);
}
.wx-image {
  width: 120px;
  height: 120px;
  margin-left: 500px;
  display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/App.vue